<div *ngIf="spinner">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header ">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">MENTOR FEEDBACK</h4>
            </div>
        </div>
        <div *ngIf="!tableshow" style="margin-left: 50%;">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="p-3 col-md-6">
                <label for="course">Select Course:</label>
                <select class="form-control" [(ngModel)]="selectedCourseId" (ngModelChange)="onCourseChange()">
                    <option value="" disabled selected>Select a course</option>
                    <option *ngFor="let course of mentor_data" [value]="course.id">{{ course.course_name }}</option>
                </select>                  
            </div>
        </div>
          <!-- Show selected course details -->
        <div *ngIf="selectedCourse">
            <h5>Course Details:</h5>
            <p><strong>Name:</strong> {{ selectedCourse.course_name }}</p>
            <p><strong>Topic:</strong> {{ selectedCourse.course_topic }}</p>
            <p><strong>Online Meet Link:</strong> <a [href]="selectedCourse.online_meet_link" target="_blank">{{ selectedCourse.online_meet_link }}</a></p>
        </div>         
        <div class="p-3" *ngIf="tableshow && courses.length > 0">
            <div class="table-responsive">
                <table class="table table-bordered display" datatable width="100%" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Course Name</th>
                            <th>Student Name</th>
                            <th>Email</th>
                            <th>Mobile No</th>
                            <th>FeedBack</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let course of courses">
                            <td>{{ course.course_name }}</td>
                            <td>{{ course.student_name }}</td>
                            <td>{{ course.student_email }}</td>
                            <td>{{ course.student_number }}</td>
                            <td>
                                <a data-toggle="modal" data-target="#myFeedBackModal" class="btn btn-primary btn-circle btn-sm" [class.disabled]="course.student_feedback === true || course.student_feedback === '1' || course.student_feedback === 'true'"
                                 (click)="show(course,'feedback')">
                                    <i class="fas fa-comment"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div id="myFeedBackModal" aria-hidden="true" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Feedback Form -->
                        <div *ngIf="modalContent === 'feedback'">
                            <form [formGroup]="feedbackForm">
                                <p><strong>Course Name:</strong> {{ selectedStudent.course_name }}</p>
                                <p><strong>Student Name:</strong> {{ selectedStudent.student_name }}</p>
                                <p><strong>Email:</strong> {{ selectedStudent.student_email }}</p>
                                <p><strong>Mobile:</strong> {{ selectedStudent.student_number }}</p>
                                <!-- Involvement Input -->
                                <div class="form-group">
                                <label for="involvement">Involvement (1-10):</label>
                                <input type="number" id="involvement" class="form-control" formControlName="involvement" min="1" max="10">
                                </div>
                                <!-- Volunteering Input -->
                                <div class="form-group">
                                <label for="volunteering">Volunteering (1-10):</label>
                                <input type="number" id="volunteering" class="form-control" formControlName="volunteering" min="1" max="10">
                                </div>
                                <!-- Performance Input -->
                                <div class="form-group">
                                <label for="performance">Performance (1-10):</label>
                                <input type="number" id="performance" class="form-control" formControlName="performance" min="1" max="10">
                                </div>
                                <!-- Overall Rating (5-Star) -->
                                <div class="form-group">
                                    <label>Overall Rating:</label>
                                    <div>
                                      <span *ngFor="let star of [1,2,3,4,5]" (click)="updateRating(star)" style="cursor: pointer;">
                                        <i class="fa fa-star" 
                                           [ngClass]="{
                                             'fas text-warning': star <= feedbackForm.value.overall_rating_about_session,
                                             'far text-muted': star > feedbackForm.value.overall_rating_about_session
                                           }">
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                  
                                <!-- Submit Button -->
                                <div class="modal-footer">
                                <button type="button" class="btn btn-primary" (click)="submitFeedback()">Submit Feedback</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>   
        </div> 
    </div>
</div>     